export default "__VITE_ASSET__DD3w9Ooq__"